import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MainRoutingModule } from "./main-routing.module";
import { MainComponent } from "./main.component";
import { FullComponent } from "../layouts/full/full.component";
import { AppSidebarComponent } from "../layouts/full/sidebar/sidebar.component";
import { AppHeaderComponent } from "../layouts/full/header/header.component";
import { SharedModule } from "../shared/shared.module";
import { UserManagementModule } from "./user-management/user-management.module";
import { GoogleChartsModule } from "angular-google-charts";
import { IntercomModule } from "ng-intercom";
import { FileService } from "../shared/fileService";
@NgModule({
  declarations: [
    MainComponent,
    FullComponent,
    AppSidebarComponent,
    AppHeaderComponent,
  ],
  imports: [
    CommonModule,
    MainRoutingModule,
    UserManagementModule,
    SharedModule,
    GoogleChartsModule,
    IntercomModule.forRoot({
      appId: "bn64enia",
      updateOnRouterChange: true, 
    }),

    // DemoMaterialModule
  ],
  providers:[FileService]
})
export class MainModule {}
